import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import useWindowSize from "../../helpers/useWindowSize";
import i18n from "i18next";
import NavMenu from "./NavMenu/NavMenu";
import "./Layout.css";
import authService from "../api-authorization/AuthorizeService";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { fetchWrapper } from "../../helpers/fetchwrapper";
import { baseUrl } from "../../helpers/constants";
import { IAppUserDto } from "../../Models/IAppUserDto";
import { securityCheck } from "../../helpers/checkSecurity";
import { IAppSetting } from "../../Models/IAppSetting";
import MaintenanceMode from "./MaintenanceMode/MaintenanceMode";
import {
  Button,
  DrawerBody,
  DrawerHeader,
  DrawerHeaderTitle,
  OverlayDrawer,
  MessageBar,
  Link,
  Image,
} from "@fluentui/react-components";
import {
  Dismiss24Regular,
  PersonFilled,
  TextAlignJustify24Filled,
  TextAlignJustifyFilled,
} from "@fluentui/react-icons";
import NavMenuEditUserDialog from "./NavMenu/NavMenuShowUser";

function Layout(props: any) {
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [navPanelOpen, setNavPanelOpen] = useState(false);
  const [benutzer, setBenutzer] = useState<IAppUserDto | undefined>();
  const [roles, setRoles] = useState([]);
  const navigate = useNavigate();

  const location = useLocation().pathname;

  useEffect(() => {
    if (location && roles && roles.length > 0) {
      if (!securityCheck.check(location, roles)) {
        navigate("/");
      }
    }
  }, [location, roles]);

  const isLocLoginComponent =
    location.toLowerCase() == "/authentication/logged-out" ||
    location.toLowerCase() == "/authentication/logout-callback" ||
    location.toLowerCase() == "/authentication/login-callback" ||
    location.toLowerCase() == "/authentication/login" ||
    location.toLowerCase() == "/account/login" ||
    location.toLowerCase() == "/account/register" ||
    location.toLowerCase() == "/account/verifyemail" ||
    location.toLowerCase() == "/account/confirmemail" ||
    location.toLowerCase() == "/account/resetpassword" ||
    location.toLowerCase() == "/account/forgotpassword"
      ? true
      : false;

  const windowSize = useWindowSize();

  const checkMaintenanceMode = () => {
    fetchWrapper
      .get(`${baseUrl}/api/account/CheckIfIsMaintanceMode`)
      .then((result: IAppSetting) => {
        if (result.value == "1") {
          setMaintenanceMode(true);
        }
      });
  };

  const getCurrentUser = () => {
    authService.getUser().then((user) => {
      if (user) {
        fetchWrapper
          .getWithAuth(`${baseUrl}/api/account/getcurrentuser`)
          .then((result: IAppUserDto) => {
            setBenutzer(result);
            // Bin eingeloggt, wir können die Rollen des Benutzers abfragen:
            fetchWrapper
              .getWithAuth(`${baseUrl}/api/account/getmyroles`)
              .then((result) => {
                setRoles(result);
              })
              .catch((error) => {});
          })
          .catch((error) => {});
      }
    });
  };

  useEffect(() => {
    checkMaintenanceMode();
    getCurrentUser();
    // Alle 5 Minuten den Benutzer aktualisieren
    const interval = setInterval(() => {
      checkMaintenanceMode();
      getCurrentUser();
    }, 60000 * 5);
    return () => clearInterval(interval);
  }, [isLocLoginComponent]);

  useEffect(() => {
    if (windowSize.width > 1024) {
      setNavPanelOpen(false);
    }
  }, [windowSize.width]);

  const [headerOpacity, setHeaderOpacity] = useState(1);
  const [prevScrollpos, setPrevScrollpos] = useState(window.pageYOffset);

  window.onscroll = function () {
    var currentScrollPos = window.pageYOffset;
    if (currentScrollPos <= 0) {
      setHeaderOpacity(1);
    } else if (prevScrollpos >= currentScrollPos) {
      if (headerOpacity != 1) {
        setHeaderOpacity(1);
      }
    } else {
      if (headerOpacity != 0) {
        setHeaderOpacity(0);
      }
    }
    setPrevScrollpos(currentScrollPos);
  };

  if (maintenanceMode == true) {
    return (
      <>
        {/* Header */}
        <div
          style={{
            background: "rgba(255,255,255,0.5)",

            opacity: headerOpacity,
            position: "fixed",
            transition: "opacity 0.6s",

            width: "100%",
            height: 60,

            backdropFilter: "blur(5px)",
            WebkitBackdropFilter: "blur(5px)",

            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",

            padding: "0px 20px 0px 20px",

            borderBottom: "1px solid #ff6600",
          }}
        >
          {/* Hamburger Button */}
          <Button
            size="large"
            /* style={{ marginTop: "10px" }} */
            icon={<TextAlignJustify24Filled color="#ff6600" />}
            appearance="transparent"
            onClick={() => setNavPanelOpen(true)}
          />
        </div>
        <div
          style={{
            fontFamily: "neueCond",
            fontSize: "1rem",
            minHeight: "100vh",
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Body */}
          <div
            style={{
              overflowY: "hidden",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div
              style={{
                minHeight: "100vh",
                height: "100%",

                display: "flex",
                flexDirection: "row",
                width: "100%",
                marginTop: "10px",
              }}
            >
              <Container>
                <MaintenanceMode />
              </Container>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (windowSize.width <= 1024 && !isLocLoginComponent && !maintenanceMode) {
    return (
      <div
        style={{
          fontFamily: "neueCond",
          fontSize: "1rem",
          minHeight: "100vh",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <div
          style={{
            opacity: headerOpacity,
            position: "fixed",
            transition: "opacity 0.6s",

            width: "100%",
            height: 60,

            backdropFilter: "blur(5px)",
            WebkitBackdropFilter: "blur(5px)",

            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* Hamburger Button */}
          <Button
            size="large"
            /* style={{ marginTop: "10px" }} */
            icon={<TextAlignJustifyFilled />}
            appearance="transparent"
            onClick={() => setNavPanelOpen(true)}
          />

          {/* Lübbering Logo */}
          <div>
            <Link
              onClick={() => {
                navigate("/");
              }}
            >
              <Image
                alt=""
                src={`${baseUrl}/LUEBBERING_DIGITAL_TRANSPARENT.PNG`}
                height={55}
              />
            </Link>
          </div>

          {/* Benutzer Icon oder Login */}
          {!benutzer && (
            <Button
              onClick={() => {
                navigate("/account/login");
                props.onNavigate();
              }}
              icon={<PersonFilled />}
              appearance="transparent"
              shape="square"
              style={{
                marginTop: "8px",
              }}
            >
              {i18n.t<string>("signIn")}
            </Button>
          )}
          {benutzer && <NavMenuEditUserDialog small={true} user={benutzer} />}
        </div>
        {/* Nav Panel */}
        <OverlayDrawer
          //320
          size="small"
          open={navPanelOpen}
        >
          <DrawerHeader>
            <DrawerHeaderTitle
              action={
                <Button
                  appearance="subtle"
                  aria-label="Close"
                  icon={<Dismiss24Regular />}
                  onClick={() => {
                    setNavPanelOpen(false);
                  }}
                />
              }
            />
          </DrawerHeader>
          <DrawerBody>
            <NavMenu
              user={benutzer}
              roles={roles}
              panelOpen={navPanelOpen}
              onNavigate={() => {
                setNavPanelOpen(false);
              }}
              phoneView={true}
            />
          </DrawerBody>
        </OverlayDrawer>
        {/* Content */}
        <div
          style={{
            marginTop: "60px",

            minHeight: "100vh",
            height: "100%",
            width: "100%",
            overflow: "auto",
          }}
        >
          <>
            {!baseUrl.includes("www.luebbering-digital.com") && (
              <div style={{ marginTop: 10 }}>
                <MessageBar intent="warning">
                  ! Testsystem ! Hier kann gefahrlos alles ausprobiert werden!
                </MessageBar>
              </div>
            )}
            <Container>{props.children}</Container>
          </>
        </div>
      </div>
    );
  } else if (
    windowSize.width > 1024 &&
    !isLocLoginComponent &&
    !maintenanceMode
  ) {
    return (
      <>
        {/* App */}
        <div
          style={{
            fontFamily: "neueCond",
            fontSize: "1rem",
            display: "flex",
            height: "100%",
            minHeight: "100vh",
          }}
        >
          {/* Body */}
          {benutzer && (
            <>
              {/* <div style={{ minWidth: "300px" }} />
              <div
                style={{
                  left: "20px",
                  top: "15px",
                  bottom: "15px",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  paddingLeft: "13px",
                  paddingRight: "13px",
                  backgroundColor: "white",
                  boxShadow: "lightgrey 0px 0px 6px 1px",
                  width: "280px",
                  borderRadius: "2px",
                  height: "fit-content",
                  position: "fixed",
                }}
              >
                <NavMenu user={benutzer} roles={roles} phoneView={false} />
              </div> */}
            </>
          )}
          <div
            style={{
              minHeight: "100vh",
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Container
              style={{
                maxWidth:
                  windowSize.width > 1400 ? 1350 : windowSize.width - 100,
              }}
            >
              {props.children}
            </Container>
          </div>
        </div>
      </>
    );
  } else {
    // sollte jetzt eine der Login/Register Komponenten sein
    // App
    return (
      <div
        style={{
          fontFamily: "neueCond",
          fontSize: "1rem",
          minHeight: "100vh",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Body */}
        <div
          style={{
            overflowY: "hidden",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div
            style={{
              minHeight: "100vh",
              height: "100%",

              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Image
              style={{
                zIndex: 0,
                position: "absolute",
                height: "100%",
                filter: "blur(1px)",
              }}
              src="/luebSignInBackground.png"
            />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                height: "100%",
              }}
            >
              {!baseUrl.includes("www.luebbering-digital.com") && (
                <div style={{ marginTop: 10, zIndex: 1 }}>
                  <MessageBar intent="warning">
                    ! Testsystem ! Hier kann gefahrlos alles ausprobiert werden!
                  </MessageBar>
                </div>
              )}
              <Container
                style={{
                  zIndex: 1,
                }}
              >
                {props.children}
              </Container>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Layout;
